import "./home.css";
import React from "react";
import hero from "../../assets/image/hero.png";
import logo from "../../assets/image/logo.svg";
import { useEffect, useState } from "react";
import divider from "../../assets/image/divider.svg";
import hamburger from "../../assets/image/hamburger.png";
import birra from "../../assets/image/birra.png";
import alcolici from "../../assets/image/alcolici.png";
import food from "../../assets/image/food.png";
import facebook from "../../assets/icons/facebook.svg";
import instagram from "../../assets/icons/instagram.svg";
import sito from "../../assets/icons/sito.svg";
import cell from "../../assets/icons/cell.svg";
import etichetta from "../../assets/image/etichetta.svg";

const Home = () => {

  const [headerClassName, setHeaderClassName] = useState("");

  const handleScroll = (headerClassName) => {
    if (headerClassName !== "topbar" && window.pageYOffset >= 300) {
      setHeaderClassName("is_sticky_home");
    } else {
      setHeaderClassName("");
    }
  };

  useEffect(() => {
    handleScroll();
    window.onscroll = () => handleScroll();
  }, [headerClassName]);

  return (
    <main className="home">
      <div id="topbar" className={`flex topbar_home ${headerClassName}`}>
        <div className="col-3"></div>
        <div className="col-6 text-center">
          <img src={logo} className="logo_home" alt="logo" />
        </div>
        <div className="col-3">
          <a href="/menu" className="a_menu">
            <img src={etichetta} className="etichetta_home" alt="" />
            <p className="menu_p">Menù</p>
          </a>
        </div>
      </div>

      <section className="container hero flex">
        <img src={hero} className="hero_img" alt="hero" />
        <img src={logo} className="logo_hero" alt="logo" />
        <h1 className="title_home">PUBLIC HOUSE</h1>
        <a href="/menu" className="a_menu">
          <img src={etichetta} className="etichetta_home" alt="" />
          <p className="menu_p">Menù</p>
        </a>

        <div className="arrow_scroll">
          <a href="#concept" className="arrow_scroll_wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="18" viewBox="0 0 38 18">
              <path fill="#ffffff" d="M19.208,18.592c-0.241,0-0.483-0.087-0.673-0.261L0.327,1.74c-0.408-0.372-0.438-1.004-0.066-1.413c0.372-0.409,1.004-0.439,1.413-0.066L19.208,16.24L36.743,0.261c0.411-0.372,1.042-0.342,1.413,0.066c0.372,0.408,0.343,1.041-0.065,1.413L19.881,18.332C19.691,18.505,19.449,18.592,19.208,18.592z"></path>
            </svg>
          </a>
        </div>
      </section>

      <section id="concept" className="container">
        <div className="subcategory_home">
          <img src={divider} className="divider" alt="" />
          <p>CONCEPT</p>
        </div>
        <div className="w-100 flex box">
          <p className="text">Back Room pub vi accoglierà in una piacevole atmosfera ispirata agli anni del proibizionismo, volutamente collocata nel meraviglioso centro storico di Avetrana, in modo che i visitatori possano apprezzarne i dettagli. Un ambiente unico nel suo genere vi accoglierà proponendovi un'esperienza fantastica in un nuovo format tra gusto e stile. La professionalità dello staff e la qualità dal nostro menù, oltre che le attenzioni che vi saranno riservate dai padroni di casa Salvatore e Vincenzo, vi faranno trascorre piacevoli momenti durante i vostri aperitivi e cene, che siate soli, in coppia o con i vostri amici. Non vi resta che venire a trovarci, vi aspettiamo.</p>
        </div>
      </section>

      <section className="container">
        <div className="w-100 div_card_home box_plus">
          <div className="card_home">
            <div className="card_home_div">
              <img src={hamburger} className="" alt="" />
              <p className="text">La nostra proposta di Hamburger Buns si distingue per l'alta qualità di tutti gli ingredienti che lo compongono. Il Bun è realizzato con lievito madre e una lunga maturazione che gli conferisce un'ottima fragranza e un'alta digeribilità. A seguire, una selezione di Hamburger di razza Marchigiana IGP (nata nella metà del XIX secolo). La Marchigiana è una delle razze bianche italiane che, insieme alla Chianina ed alla Romagnola, ha avuto il riconoscimento IGP per la carne bovina in Italia con la denominazione “Vitellone Bianco dell'Appennino Centrale”. La carne che si ottiene dalla Marchigiana è tenera, di ottimo sapore, dall’elevato contenuto proteico e dai bassi livelli di colesterolo.</p>
            </div>
          </div>

          <div className="card_home">
            <div className="card_home_div">
              <img src={birra} className="" alt="" />
              <p className="text">Servire la birra a regola d'arte per noi di Back Room Pub è di fondamentale importanza, ed è per questo che abbiamo scelto di installare una cella per fusti a temperatura controllata. Questo sistema di spillatura garantisce notevoli differenze rispetto ad un tradizionale impianto, poichè preserva la birra dagli shock termici ed evita di compromettere le sue qualità organolettiche. Inoltre, la birra viene spinta nell'impianto con meno pressione e ciò la rende più digeribile. Noi del Back Room Pub seguiamo con attenzione la fase di spillatura nel bicchiere, garantendo volume e vitalità alla schiuma e andando a preservare le caratteristiche organolettiche, isolando la birra da contaminazioni esterne.</p>
            </div>
          </div>

          <div className="card_home">
            <div className="card_home_div">
              <img src={food} className="" alt="" />
              <p className="text">La proposta food di Back Room Pub è incentrata nel proporre sfiziosità per golosi aperitivi o inizio cena, antipasti e piatti unici semplici ma ricercati e di alta qualità. La cultura verso il mondo della ristorazione è una tradizione in Back Room Pub, infatti lo chef Vincenzo oltre che uno dei padroni di casa è uno chef e pizzaiolo molto conosciuto nel settore, che nei suoi anni di esperienza ha formato ai massimi livelli anche l'intero staff della sua cucina, apportando proposte sempre innovative per poter soddisfare il palato di ogni singolo cliente, anche di quello più esigente.</p>
            </div>
          </div>
          <div className="card_home">
            <div className="card_home_div">
              <img src={alcolici} className="" alt="" />
              <p className="text">La selezione dei distillati di Back Room Pub è espressione di un lungo periodo di analisi e scelta dei prodotti. Grazie all'attenzione riservata alla ricerca di aziende specializzate nel mondo della distillazione, abbiamo selezionato i migliori prodotti adatti a garantire elevati standard di qualità. Non vi resta che accomodarvi, rilassarvi e degustare ogni nostro distillato o drink.</p>
            </div>
          </div>
        </div>
        <div className="col-12">
          <a href="/menu" className="a_menu p-0">
            <img src={etichetta} className="etichetta_home" alt="" />
            <p className="menu_p">Menù</p>
          </a>
        </div>
      </section>

      <section className="container">
        <div className="subcategory_home">
          <img src={divider} className="divider" alt="" />
          <p>DOVE SIAMO</p>
        </div>
        <div className="w-100 flex box">
          <iframe title="maps" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12162.54601891465!2d17.7261517!3d40.3504089!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13469359568bed97%3A0xc9f1f73e9023543d!2sBack%20Room%20Pub!5e0!3m2!1sit!2sit!4v1685348112483!5m2!1sit!2sit" width="100%" height="450" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </section>

      <section className="container">
        <div className="subcategory_home">
          <img src={divider} className="divider" alt="" />
          <p>CONTATTI</p>
        </div>

        <div className="flex direction-column row-gap-15 contatti  item-center pt-1">
          <div className="flex gap15">
            <a href="https://www.facebook.com/backroompub">
              {" "}
              <div className="div_icon">
                <img src={facebook} className="" alt="" />
              </div>
            </a>
            <a href="https://www.instagram.com/backroompub/">
              <div className="div_icon">
                <img src={instagram} className="" alt="" />{" "}
              </div>
            </a>
          </div>
          <a href="mailto:info@backroompub.it">
            <div className="div_icon">
              <img src={sito} className="" alt="" />{" "}
            </div>{" "}
            info@backroompub.it
          </a>
          <a href="tel:+393898173700">
            <div className="div_icon">
              <img src={cell} className="" alt="" />
            </div>{" "}
            +39 389 8173 700
          </a>
        </div>
      </section>
    </main>
  );
};

export default Home;

// Link dove troverai le props per customizzare il componente
// https://github.com/yifaneye/react-gallery-carousel
